import React from 'react';
import { ZdsDivider, ZdsIcon, ZdsItem } from '@zig-design-system/ui-components-react';
const ActionResult = ({ hit }) => {
    var _a, _b;
    const [iconLibrary, iconName] = (_b = (_a = hit._source.fields.icon) === null || _a === void 0 ? void 0 : _a.split('_')) !== null && _b !== void 0 ? _b : [];
    return (React.createElement("div", null,
        React.createElement(ZdsItem, { link: hit._source.url },
            iconLibrary && iconName && (React.createElement("div", { slot: "content-start", className: "search-list-icon zds-flex-col zds-items-center" },
                React.createElement(ZdsIcon, { className: "zds-color-primary", library: iconLibrary, name: iconName, size: "xl" }))),
            React.createElement("div", { slot: "primary-text", className: "zds-bold zds-truncate" }, hit._source.title)),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
export default ActionResult;
